import { useMutation } from '@connectrpc/connect-query'

import { emailVerified } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { EmailVerifiedResponse } from '~/gen/proto/bff/v1/common_pb'

export function useEmailVerified(
  onSuccess: (data: EmailVerifiedResponse) => void,
): ReturnType<typeof useMutation> {
  return useMutation(emailVerified, {
    onSuccess: (data) => {
      onSuccess(data)
    },
  })
}
